import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const listViewTemplates = gql`
  query ListViewTemplatesQuery($input: ListViewTemplates!) {
    listViewTemplates(input: $input) {
      ...ViewTemplate
    }
  }
  ${Fragments.viewTemplate.ViewTemplate}
`;

export const listViewTemplatesV2 = gql`
  query ListViewTemplatesQueryV2($input: ListViewTemplates!) {
    listViewTemplatesV2(input: $input) {
      viewTemplates {
        ...ViewTemplate
      }
      hasMore
    }
  }

  ${Fragments.viewTemplate.ViewTemplate}
`;

export const getViewTemplate = gql`
  query GetViewTemplateQuery($input: GetViewTemplate!) {
    getViewTemplate(input: $input) {
      ...ViewTemplate
    }
  }

  ${Fragments.viewTemplate.ViewTemplate}
`;

export const getViewTemplateWithUITemplate = gql`
  query GetViewTemplateQueryWithUITemplate($input: GetViewTemplate!) {
    getViewTemplate(input: $input) {
      ...ViewTemplate
      cardUITemplate {
        template
      }
    }
  }

  ${Fragments.viewTemplate.ViewTemplate}
`;

export const getViewTemplateLayout = gql`
  query GetViewTemplateLayoutQuery($input: GetViewTemplateLayout!) {
    getViewTemplateLayout(input: $input) {
      ...ViewTemplateLayout
    }
  }

  ${Fragments.viewTemplate.ViewTemplateLayout}
`;
